import React from "react";
import { Leaf, Package, ShieldCheck, Sparkles } from "lucide-react";

const CATALOG = [
  { name: "Desi Garlic Seed – Mandsauri", brand: "Local Farm", pack: "5 kg", price: 850, tag: "Desi", img: "https://images.unsplash.com/photo-1768676124561-d14c038afbdb?w=600&q=80" },
  { name: "G-282 (G2) Certified Seed", brand: "IARI", pack: "10 kg", price: 2200, tag: "G2", img: "https://images.unsplash.com/photo-1565801776223-62c24688477c?w=600&q=80" },
  { name: "Amleta Improved Variety", brand: "Krishi Vibhag", pack: "5 kg", price: 950, tag: "Amleta", img: "https://images.unsplash.com/photo-1695842522138-040125b54a85?w=600&q=80" },
  { name: "Yamuna Safed-1 (G-1)", brand: "IARI", pack: "10 kg", price: 2400, tag: "Premium", img: "https://images.unsplash.com/photo-1768676124561-d14c038afbdb?w=600&q=80" },
  { name: "Agrifound Parvati Hybrid", brand: "NHRDF", pack: "5 kg", price: 1100, tag: "Hybrid", img: "https://images.unsplash.com/photo-1565801776223-62c24688477c?w=600&q=80" },
  { name: "Organic Certified Bulblets", brand: "Local Coop", pack: "3 kg", price: 720, tag: "Organic", img: "https://images.unsplash.com/photo-1695842522138-040125b54a85?w=600&q=80" },
];

const Beej = () => (
  <div data-testid="beej-page" className="bg-[#FDFBF7]">
    <section className="border-b border-stone-200 bg-gradient-to-b from-[#F4F1EA] to-[#FDFBF7]">
      <div className="container-gc px-4 sm:px-6 py-12 sm:py-16">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-stone-200 text-xs font-medium text-[#1E4D2B] mb-5">
          <Leaf size={14} /> Beej · Certified Garlic Seeds
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-stone-900 leading-tight">Beej Catalog</h1>
        <p className="mt-4 text-lg text-stone-700 max-w-2xl leading-relaxed">
          Certified garlic seed varieties from IARI, NHRDF and trusted local growers. Optimised for Rajasthan, MP, and Gujarat climates.
        </p>
        <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-100 text-amber-800 text-xs font-semibold">
          <Sparkles size={14} /> Ordering flow — Coming Soon
        </div>
      </div>
    </section>

    <section className="container-gc px-4 sm:px-6 py-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {CATALOG.map((p, i) => (
        <article key={i} data-testid={`beej-item-${i}`} className="card-gc overflow-hidden flex flex-col hover:shadow-md transition-shadow">
          <div className="aspect-[4/3] bg-stone-100 overflow-hidden">
            <img src={p.img} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div className="p-5 flex flex-col flex-1">
            <div className="flex items-center justify-between gap-2 mb-2">
              <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-[#F4F1EA] text-[#1E4D2B]">{p.tag}</span>
              <span className="text-xs text-stone-500">{p.brand}</span>
            </div>
            <h3 className="text-lg font-bold text-stone-900">{p.name}</h3>
            <p className="text-sm text-stone-600 mt-0.5 flex items-center gap-1"><Package size={13} /> {p.pack}</p>
            <div className="mt-3 text-2xl font-bold text-[#1E4D2B]">₹{p.price}<span className="text-xs text-stone-500 font-normal"> /pack</span></div>
            <button disabled className="btn-primary mt-4 !bg-stone-300 hover:!bg-stone-300 cursor-not-allowed opacity-70">
              <ShieldCheck size={16} /> Coming Soon
            </button>
          </div>
        </article>
      ))}
    </section>
  </div>
);

export default Beej;
